import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';

import ModalPortal from '../../../../../components/modal-portal/index';

import messages from '../../../messages';
import style from './delete-products.module.less';

const DeleteProductModal = ({ onClose, onDelete }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style.modal} size='large'>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage {...messages.deleteModalHeader} />
        </ModalHeader>
        <ModalBody className={style['delete-product-modal-body']}>
          <div className={style.warning}>
            <p>
              <FormattedMessage {...messages.deleteModalBodyTitle} />
            </p>
            <p>
              <FormattedMessage {...messages.deleteModalBodyText1} />
            </p>
            <p>
              <FormattedMessage {...messages.deleteModalBodyText2} />
            </p>
            <p>
              <FormattedMessage {...messages.deleteModalBodyText3} />
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onDelete} theme='danger'>
            <FormattedMessage {...messages.deleteModalConfirmation} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

DeleteProductModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteProductModal;
